import React from "react";
import { useNavigate } from "react-router-dom";

import {
  SCHOOL_ID_QUERY_PARAM,
  SEARCH_SCHOOL_LIST_FIELDS,
  SCHOOL_STATUS_LABELS,
  VIEW_DASH,
} from "constants/schoolConstants";
import routes from "constants/routes";

import styles from "./SchoolsList.module.scss";

const SchoolsList = ({ schools }) => {
  const navigate = useNavigate();
  return (
    <ul className={styles.schoolList}>
      {schools.map((school) => (
        <li key={school.schoolId} className={styles.schoolListItem}>
          <button
            type="button"
            className={styles.schoolItem}
            onClick={() =>
              navigate(
                `${routes.schoolDetails.schoolDetails}?${SCHOOL_ID_QUERY_PARAM}=${school.schoolId}`,
              )
            }
            aria-label={`View details for ${school.schoolName}, school code ${school.schoolCode || school.schoolId}`}
          >
            <div className={styles.cardTop}>
              <div className={styles.schoolTitleBlock}>
                <span className={styles.schoolName}>{school.schoolName}</span>
              </div>
              {school.status ? (
                <span className={styles.statusBadge} data-status={school.status}>
                  {SCHOOL_STATUS_LABELS[school.status] || school.status}
                </span>
              ) : null}
            </div>
            <dl className={styles.metaGrid}>
              {SEARCH_SCHOOL_LIST_FIELDS.map(({ key, label }) => {
                const value = school[key] || VIEW_DASH;
                return (
                  <div key={key} className={styles.metaRow}>
                    <dt className={styles.metaLabel}>{label}</dt>
                    <dd className={styles.metaValue} title={school[key] || undefined}>
                      {value}
                    </dd>
                  </div>
                );
              })}
            </dl>
          </button>
        </li>
      ))}
    </ul>
  );
};

export default SchoolsList;
